import slick from "slick-carousel";
import fancybox from "@fancyapps/fancybox";
import Masonry from 'masonry-layout';


var msnGrid = document.querySelector('.msn');
if (msnGrid) {
    var msnry = new Masonry(msnGrid, {
        // options...
        itemSelector: '.msn-item',
        percentPosition: true,
    });
}


$(function () {
    /* news slider */
    $("#newsSlider").slick({
        autoplay: true,
        autoplaySpeed: 8000,
        pauseOnFocus: false,
        pauseOnHover: false,
        speed: 1500,
        arrows: false,
        dots: false,
        centerMode: false,
        fade: true,
    });

    /* page pictures slider */
    $("#photosSlider").slick({
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnFocus: false,
        pauseOnHover: false,
        speed: 1500,
        arrows: false,
        dots: false,
        centerMode: false,
        fade: true,
        adaptiveHeight: true
    });

    /* page gallery slider */
    $("#gallerySlider").slick({
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnFocus: false,
        pauseOnHover: false,
        speed: 1500,
        arrows: false,
        dots: false,
        centerMode: false,
        fade: true,
    });

    $("#logosSlider").slick({
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnFocus: false,
        pauseOnHover: false,
        speed: 1500,
        arrows: false,
        dots: false,
        centerMode: false,
        fade: true,
    });

    /* FANCYBOX */
    $("a.fancybox").fancybox({
        loop: true,
        keyboard: true,
    });
});


